import {QuestionComponent} from './QuestionComponent'
import {Matrix} from 'app/models/questions/Matrix'
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms'
import {
  ImageUploadComponent
} from "../../modules/survey/survey-viewer/survey-question/types/image-upload/image-upload.component";

export class ImageUpload extends Matrix {

  getDisplayComponent() {
    return new QuestionComponent(ImageUploadComponent, this)
  }

  buildStatementFormGroup(): UntypedFormGroup {
    const form = new UntypedFormGroup({})

    this.statementKeys.forEach(sKey => form.addControl(sKey, new UntypedFormControl(true, {})))
    return form
  }
}
